import {
  ocrService,
  type BusinessLicense,
  type PrescriptionLine,
  type PromoLicense,
} from '@/entities/ocr/api/ocr.api';
import { useMutation } from '@tanstack/react-query';

export const ocrKeys = {
  all: ['ocr'] as const,
};

export const useOcrPrescription = () =>
  useMutation({
    mutationFn: (imageUrl: string) =>
      ocrService.ocrPrescriptionImage({ imageUrl }),
  });

export const useOcrPrescriptionFile = () =>
  useMutation({
    mutationFn: (file: File) => ocrService.ocrPrescriptionFile(file),
  });

export const useOcrBusinessLicense = () =>
  useMutation({
    mutationFn: (imageUrl: string) =>
      ocrService.ocrBusinessLicense({ imageUrl }),
  });

export const useOcrPromoLicense = () =>
  useMutation({
    mutationFn: (imageUrl: string) => ocrService.ocrPromoLicense({ imageUrl }),
  });

export type { BusinessLicense, PrescriptionLine, PromoLicense };
